'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render", "style", "start", "end"];
import * as React from 'react';
import { useStore } from '@base-ui/utils/store';
import { useElementPositionInCollection, useEvent } from '@mui/x-scheduler-internals/internals';
import { useRenderElement } from '@mui/x-scheduler-internals/base-ui-copy';
import { useEventTimelinePremiumStoreContext } from "../../use-event-timeline-premium-store-context/index.mjs";
import { TimelineGridEventPlaceholderCssVars } from "./TimelineGridEventPlaceholderCssVars.mjs";
import { eventTimelinePremiumPresetSelectors } from "../../event-timeline-premium-selectors/index.mjs";
import { TimelineGridEventPlaceholderDataAttributes } from "./TimelineGridEventPlaceholderDataAttributes.mjs";
const overflowStateAttributesMapping = {
  startingBeforeEdge: value => value ? {
    [TimelineGridEventPlaceholderDataAttributes.startingBeforeEdge]: ''
  } : null,
  endingAfterEdge: value => value ? {
    [TimelineGridEventPlaceholderDataAttributes.endingAfterEdge]: ''
  } : null
};
export const TimelineGridEventPlaceholder = /*#__PURE__*/React.forwardRef(function TimelineGridEventPlaceholder(componentProps, forwardedRef) {
  const {
      // Rendering props

      // Internal props
      start,
      end
      // Props forwarded to the DOM element
    } = componentProps,
    elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);

  // Context hooks
  const store = useEventTimelinePremiumStoreContext();

  // Selector hooks
  const presetConfig = useStore(store, eventTimelinePremiumPresetSelectors.config);

  // Feature hooks
  const {
    position,
    duration,
    startingBeforeEdge,
    endingAfterEdge
  } = useElementPositionInCollection({
    start,
    end,
    collectionStart: presetConfig.start,
    collectionEnd: presetConfig.end
  });
  const {
    state: eventState
  } = useEvent({
    start,
    end
  });
  const state = _extends({}, eventState, {
    startingBeforeEdge,
    endingAfterEdge
  });
  return useRenderElement('div', componentProps, {
    state,
    ref: [forwardedRef],
    props: [elementProps, {
      style: {
        [TimelineGridEventPlaceholderCssVars.xPosition]: `${position * 100}%`,
        [TimelineGridEventPlaceholderCssVars.width]: `${duration * 100}%`
      }
    }],
    stateAttributesMapping: overflowStateAttributesMapping
  });
});
if (process.env.NODE_ENV !== "production") TimelineGridEventPlaceholder.displayName = "TimelineGridEventPlaceholder";